import React from 'react'
import {BsLinkedin, BsGithub} from 'react-icons/bs'
import {FaFacebookMessenger} from 'react-icons/fa'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
      <a href='http://linkedin.com' target='_blank'><BsLinkedin/></a>
      <a href='http://github.com' target='_blank'><BsGithub/></a>
      <a href='http://facebook.com' target='_blank'><FaFacebookMessenger/></a>
    </div>
  )
}

export default HeaderSocials